import { render } from "./OnBoardingCard.vue?vue&type=template&id=2cd9d9b4&scoped=true&ts=true"
import script from "./OnBoardingCard.vue?vue&type=script&lang=ts"
export * from "./OnBoardingCard.vue?vue&type=script&lang=ts"

import "./OnBoardingCard.vue?vue&type=style&index=0&id=2cd9d9b4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd9d9b4"]])

export default __exports__